import { gql } from "graphql-tag";

/**
 * Fetches sales configurations
 *
 * variable example
 * {"groupId": "(groupId,eq,12026)"}
 */
export const GET_PosConfigs = gql`
  query GET_PosConfigs($groupId: String!, $condition: ConditionNewPosConfig) {
    salesConfigs: NewPosConfigList(where: $groupId, condition: $condition) {
      id: Id
      name: Name
      description: Description
      status: Status
      users: Users
      groupId: GroupId
      ticketGroups: TicketGroups
      gridsInfo: GridsInfo
      isRefundActivated: IsRefundActivated
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

/**
 * Fetches sales configurations
 *
 * variable example
 * {"id": "(id,eq,1)"}
 */
export const GET_PosConfig = gql`
  query GET_PosConfig($id: String!) {
    salesConfigs: NewPosConfigList(where: $id) {
      id: Id
      name: Name
      description: Description
      status: Status
      users: Users
      groupId: GroupId
      ticketGroups: TicketGroups
      gridsInfo: GridsInfo
      isRefundActivated: IsRefundActivated
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;
